module.exports = __webpack_public_path__ + "static/Play_Store-6b03f0d0cc4a3c429516dd4ce8c20da8.png";